import styled from "styled-components";

export const TabWrapper = styled.div`
  margin: 16px 16px 0px;
`;
